const productReviewsVideo = ()=>({
  init(){

  },
  playVideo($el) {
    const videoPlayer = $el.parentElement.querySelector("video")
    const pauseButton = $el.parentElement.querySelector("[data-pause]")
    const playButton = $el.parentElement.querySelector("[data-play]")
    videoPlayer?.play()
    playButton?.classList.add("hide")
    pauseButton?.classList.remove("hide")
    setTimeout(()=>{
      this.hidePauseButton(pauseButton)
    }, 700)
  },
  pauseVideo($el) {
    const videoPlayer = $el.parentElement.querySelector("video")
    const pauseButton = $el.parentElement.querySelector("[data-pause]")
    const playButton = $el.parentElement.querySelector("[data-play]")
    videoPlayer?.pause()
    playButton?.classList.remove("hide")
    pauseButton?.classList.add("hide")
  },
  hidePauseButton(button){
    button?.classList.add("hide")
  }
})

export default productReviewsVideo

window.addEventListener("alpine:init", ()=>{
  Alpine.data("review_videos", productReviewsVideo)
})
